import React from 'react';
import { Link } from 'react-router-dom'
import logo from '../../../assets/images/logo.png'

const RegistrationCvHeaderView = (props) => {
    return (
        <>
         
                <div className="container-fluid">
                    <nav className="cc-header_nav navbar">
                        <a to="/home" className="navbar-brand">
                            <img src={logo} alt="logo image" className="cc-logo" />
                        </a>
                        {/* <a className="navbar-brand" href="#"><img src={logo} alt="logo image" className="cc-logo" /></a> */}
                         {props.first_name && localStorage.getItem('token') ?
                            <li className='mobile_hide'  style={{listStyleType: "none"}}>Welcome {props.first_name} {props.last_name}</li>
                            :
                            null
                         }
                        <ul className="ml-auto cc-header_contactlist">
                             {props.id && localStorage.getItem('token') ?
                            <li className='mobile_hide' >ID : {props.id}</li>
                            :
                            null
                            }
                            <li className='mobile_hide' ><a href="tel:+97142314828" className="cc-phone_no"><i className="fa fa-phone" aria-hidden="true"></i> +97142314828</a></li>
                            <li className='mobile_hide' ><button type="button" className="btn btn-blue shape-rounded"><i className="fa fa-user button-icon" aria-hidden="true"></i></button></li>

                            <li>
                                <div className={props.manuClass} style={{overflow:'auto'}}>
                                    <button onClick={props.closeMenuBar} className="sidebarClose"><i className="fa fa-times" aria-hidden="true"></i></button>
                                    <ul onClick={props.closeMenuBar} className="cc-header_menulist">
                                        
                                        {localStorage.getItem('token') ?
                                        <li onClick={props.handlelogout}>
                                            <a >Log Out</a>
                                        </li>
                                        :
                                        null
                                        }
                                        {localStorage.getItem('token') && localStorage.getItem('is_admin') ?
                                        <li onClick={props.handleadmin}>
                                            <a href='/admin/applicants-dashboard' >Applicants Dashboard</a>
                                        </li>
                                        :
                                        null
                                        }
                                        <li className='mobile_show' >
                                         <a href="tel:+97142314828"><i className="fa fa-phone" aria-hidden="true"></i> +97142314828</a>
                                         </li>
                                    </ul>
                                </div>
                                <button onClick={props.showMenuBar} className="sidebarBtn" type="button">
                                    <span></span>
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
      
        </>
    )
}

export default RegistrationCvHeaderView;